/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

import { storageKeys } from 'settings';
import {
  APIHandler,
  BackButton,
  DataHandler,
  Diploma,
  StorageHandler,
  TrainingGrid,
  ContentHeader,
  Progress,
} from 'C4';

const getTotalProgress = (res) => {
  let totalProgress = 0;
  if (res && res.data && res.data[0]) {
    const { chapters } = res.data[0];
    chapters
      .filter((chapter) => !!chapter.specialization === false)
      .forEach((chapter) => {
        totalProgress += chapter.progress;
      });
  }
  return totalProgress;
};

const getTotalPages = (res) => {
  let totalPages = 0;
  if (res && res.data && res.data[0]) {
    const { chapters } = res.data[0];
    chapters
      .filter((chapter) => !!chapter.specialization === false)
      .forEach((chapter) => {
        totalPages += chapter.total_pages - 1;
      });
  }
  return totalPages;
};

// Makes sure progress is returned in percentage value
const calculateProgress = (progress, pages) => Math.floor((progress / pages) * 100);
export default class TrainingView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      totalProgressValue: 0,
      diploma: 0,
      graduated: false,
      hasViewedDiploma: false,
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.getUserInfo();
    this.getViewedDiploma();
  }

  componentDidUpdate() {
    const { diploma, totalProgressValue, graduated } = this.state;
    if (totalProgressValue >= 100 && diploma !== 100) {
      this.setState({ diploma: 100 });
    }

    this.updateGraduated(diploma, graduated);
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  async getViewedDiploma() {
    const hasViewedDiploma = await StorageHandler.load(storageKeys.hasViewedDiploma);

    if (hasViewedDiploma === undefined) {
      StorageHandler.save(storageKeys.hasViewedDiploma, false);
    } else {
      this.setState({ hasViewedDiploma });
    }
  }

  getUserInfo() {
    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        const { email } = res.response;
        DataHandler.matchAppId().then((appId) => {
          APIHandler.getUserProgress(appId, email).then((userProgress) => {
            const totalProgress = getTotalProgress(userProgress);
            const totalPages = getTotalPages(userProgress);
            const percentage = calculateProgress(totalProgress, totalPages);
            this.setState({
              totalProgressValue: percentage >= 100 ? 100 : percentage,
            });

            if (percentage >= 100) {
              this.setState({ diploma: 100 });
            } else {
              this.setState({ diploma: 0 });
            }
          });
          StorageHandler.load(storageKeys.user).then((user) => {
            const { first_name: firstName, last_name: lastName } = user.response;
            this.setState({ firstName, lastName, appId });
          });
        });
      } else {
        this.setState({ totalProgressValue: 0 });
      }
    });
  }

  async updateGraduated(diploma, graduated) {
    if (diploma >= 100 && !graduated) {
      const d = new Date(Date.now());
      const leading = (val) => `0${val}`.slice(-2);
      const { response: user } = (await StorageHandler.load(storageKeys.user)) || {};
      if (user && user.training_graduated === null) {
        const newUser = user;
        const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(d.getDate())}`;
        const appId = await DataHandler.matchAppId();

        const res = await APIHandler.updateUser(appId, user.email, [
          { param: 'sales_companion_registered', val: date },
          { param: 'training_started', val: date },
          { param: 'training_graduated', val: date },
        ]);

        if (res && newUser && newUser.response) {
          newUser.response.sales_companion_registered = date;
          newUser.response.training_started = date;
          newUser.response.training_graduated = date;
          StorageHandler.save(storageKeys.user, newUser);
        }
      }
      this.setState({ graduated: true });
    }
  }

  render() {
    const { history } = this.props;
    const { diploma, firstName, lastName, appId, totalProgressValue, hasViewedDiploma } =
      this.state;

    const { finished, canceled } = JSON.parse(localStorage.getItem('fastTrackData')) || {};
    const fastTrackAvailable = !(finished || canceled);

    return (
      <div className="contentContainer trainingView">
        <ContentHeader
          header={i18n.translate('contentHeaders.train')}
          subtitle={i18n.translate('pageDescriptions.train')}
        >
          <div className="container__Progress">
            <div className="container__progressBar">
              <h6 className="progressText">{`${totalProgressValue}% Complete`}</h6>
              <Progress id="progress" value={totalProgressValue} />
            </div>
            <a
              className={`container__progressDiploma ${
                totalProgressValue === 100 ? 'completed' : ''
              }`}
              role="button"
              tabIndex={-1}
              data-fancybox
              data-src="#diploma"
              data-options='{"toolbar" : "true", "buttons" : ["close"]}'
              href="javascript:;"
              style={{ pointerEvents: diploma === 100 ? 'auto' : 'none' }}
            >
              <FontAwesomeIcon
                icon={['fas', 'file-certificate']}
                className={diploma === 100 ? 'completed' : ''}
              />
              <p className="text__viewDiploma">
                {diploma === 100 && i18n.translate('nav.reportCard')}
              </p>
            </a>
            <style>
              {
                '\
            #openWidget { display: block; } '
              }
            </style>
          </div>
        </ContentHeader>
        {fastTrackAvailable ? (
          <Link to="/main/fasttrack/chapter/0/0" className="backLink fastTrackBtn">
            <p>{i18n.translate('trainingScreens.fastTrackButton')}</p>
          </Link>
        ) : (
          <div />
        )}
        <TrainingGrid history={history} />
        <Diploma
          appId={appId}
          firstName={firstName}
          lastName={lastName}
          trigger={diploma === 100 && !hasViewedDiploma}
          onClose={() => {
            StorageHandler.save(storageKeys.hasViewedDiploma, true);
          }}
        />
      </div>
    );
  }
}

Diploma.propTypes = {
  appId: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  history: PropTypes.shape(),
};

Diploma.defaultProps = {
  firstName: 'John',
  lastName: 'Doe',
  history: null,
};
